import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './ProductDetail.scss';
type ProductDetailProps = {
  className?: string;
  detailKey?: string;
  detailValue?: string;
};

const ProductDetail = ({
  className,
  detailKey,
  detailValue,
}: ProductDetailProps) => {
  if (detailValue) {
    return (
      <p className={cn(s.detailsWrapper, className)}>
        <span className={s.detailKey}>{detailKey}:</span>
        <span className={s.detailValue}>{detailValue}</span>
      </p>
    );
  }
  return null;
};

export default ProductDetail;
